/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useMutation, useQuery } from '@tanstack/react-query';
import { FileText, Lightbulb } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, ErrorText, Input } from '@/components/ui';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { fmtDate } from '@/lib/format';

/** M24 Подсказки по исполнительному производству: следующее действие, прогноз, черновики заявлений */
export function WritAdvisor({ id }: { id: string }) {
  const { can } = useAuth();
  const [extra, setExtra] = useState('');
  const { data: next } = useQuery({ queryKey: ['writ-next', id], queryFn: () => api.get<any>(`/enforcement/writs/${id}/next`) });
  const { data: fc } = useQuery({ queryKey: ['writ-forecast', id], queryFn: () => api.get<any>(`/enforcement/writs/${id}/forecast`) });
  const draft = useMutation({ mutationFn: (kind: string) => api.post<any>(`/enforcement/writs/${id}/draft`, { kind, extra: extra || undefined }) });
  return (
    <div className="rounded border border-brand-100 bg-brand-50/40 p-3">
      <div className="mb-2 flex items-center gap-2 text-sm font-medium"><Lightbulb size={16} />Что сделать дальше</div>
      <ul className="space-y-2 text-sm">
        {(next?.actions ?? []).map((a: any) => (
          <li key={a.code} className="flex items-start justify-between gap-3">
            <div><div className="font-medium">{a.title}</div><div className="text-slate-600">{a.why}</div></div>
            {a.draft && can('writ.write') && <Button size="sm" variant="secondary" disabled={draft.isPending} onClick={() => draft.mutate(a.draft)}><FileText size={14} />Черновик</Button>}
          </li>
        ))}
      </ul>
      {can('writ.write') && <Input className="mt-2" placeholder="Дополнительные сведения для черновика (необязательно)" value={extra} onChange={(e) => setExtra(e.target.value)} />}
      {draft.isPending && <div className="mt-2 text-sm text-slate-500">Готовлю черновик...</div>}
      <ErrorText error={draft.error} />
      {draft.data && <div className="mt-2 text-sm">Черновик сохранён: <Link className="text-brand-700 hover:underline" to={`/documents?open=${draft.data.documentId}`}>{draft.data.title}</Link>. Проверьте текст перед подачей.</div>}
      {fc && <div className="mt-3 border-t border-brand-100 pt-2 text-xs text-slate-600">
        Прогноз: {fc.completionRate != null ? `исполняется ${fc.completionRate}% похожих производств, взыскивается ${fc.collectedShare}% суммы` : 'нет истории завершённых производств'}
        {fc.medianDays ? `, медианный срок ${fc.medianDays} дн.` : ''}{fc.expectedDate ? ` Ожидаемое окончание: ${fmtDate(fc.expectedDate)}.` : ''} {fc.note}
      </div>}
    </div>
  );
}
